import { send } from 'loot-core/src/platform/client/fetch';

import { APP_CONFIG } from './app-config';

function _authorize(
  pushModal,
  { onSuccess, onClose },
  repairAccountId?: string,
) {
  pushModal('quiltt-external-msg', {
    isRepairFlow: !!repairAccountId,
    onMoveExternal: async (connectorName?: string) => {
      let session;
      if (repairAccountId) {
        session = await send('quiltt-create-repair-session', {
          accountId: repairAccountId,
        });
      } else {
        session = await send('quiltt-create-link-session', {
          connectorName,
        });
      }

      const url =
        APP_CONFIG.quilttLinkServer +
        '/static/bank-linking/index.html?session_id=' +
        session.session_id;
      window.Actual?.openURLInBrowser(url);

      const { error, data } = await send('quiltt-poll-session', {
        sessionId: session.session_id,
      });
      return { error, data };
    },

    onClose,
    onSuccess,
  });
}

export async function authorizeBank(
  pushModal,
  { upgradingAccountId }: { upgradingAccountId?: string } = {},
) {
  // @TODO: upgradingAccountId is not used properly
  _authorize(pushModal, {
    onSuccess: async data => {
      pushModal('select-linked-accounts', {
        accounts: data.accounts,
        requisitionId: data.institution.id,
        upgradingAccountId,
        syncSource: 'quiltt',
      });
    },
    onClose: () => {
      // @TODO ?
    },
  });
}

export async function reauthorizeBank(pushModal, connectionId, onSuccess) {
  _authorize(
    pushModal,
    {
      onSuccess: async data => {
        onSuccess(data);
      },
      onClose: () => {
        // @TODO ?
      },
    },
    connectionId,
  );
}

export async function authorizeBankForAIOnboarding(
  pushModal,
  onSuccess,
  onClose,
) {
  _authorize(
    pushModal,
    {
      onSuccess,
      onClose,
    },
  );
}
